<div class="control-head">

  <div class="logo">
    <img  src="/assets/logo/logo.png">
    <!-- <span>evertracker</span> -->
  </div>

  <div class="menu-button">
<!--
    <button mat-icon-button class="toggle-sidebar-folded" (click)="toggleSidebar()">
      <mat-icon class="secondary-text" [ngStyle]="{'transform': opened ? 'rotate(90deg)' : 'rotate(270deg)'}">arrow_circle_down</mat-icon>
    </button> -->

  </div>

</div>

<div class="profile hidden" style="display: none">
  <p class="name">{{user().FirstName + ' ' + user().LastName}}</p>
  <p class="email">{{user().Email}}</p>

  <div class="picture pointer" [routerLink]="['/shipments']" style="outline: none">
    <img src="/assets/logo/logo-white.png">
  </div>
</div>

<app-navigator [navigationMenu]="navigation" style="margin-top: 10vh !important;"></app-navigator>

<!-- <div class="profile-links flex flex-col justify-center items-center">
  <div class="first-links">
    <a [routerLink]="['/data-privacy']" i18n="Data privacy text|@@main-data privacy link">{{'data privacy link' | translate}}</a>

    <a [routerLink]="['/imprint']" i18n="Imprint link text|@@main-imprint link">{{'imprint link' | translate}}</a>
  </div>

  <a [routerLink]="['/terms-and-conditions']" i18n="Terms and Conditions text|@@main-terms conditions link">{{'terms conditions link' | translate}}</a>
</div> -->
